import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import Panel from 'Common/Layout/Panel';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';
import ActionButton from 'Common/Buttons/ActionButton';
import Styles from './UploadTemplate.module.css';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';

const UploadTemplateView = ({
    title,
    handleSelectClick,
    inputRef,
    handleFileSelect,
    filename,
    handleUploadClick,
    year,
    yearSelectorHide,
    selectedYear,
    grouping,
    updateYear,
    uploadResult,
    onClose
}) => (
    <Page title={title} fitScreen>
        <Section>
            
                <Section className={yearSelectorHide ? Styles.hide : ''}>
                    <Panel title="Select Year">
                    <YearSelector grouping={grouping} updateYear={updateYear} year={year} numberOfPreviousYears={1} numberOfFutureYears={1}  />
                    </Panel>
                </Section>
            <Panel title="Select File">
                <input ref={inputRef} type="file" className={Styles.input} onChange={handleFileSelect} accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
                
                <div className={Styles.container}>
                    <ActionButton text="Select Template" onClick={handleSelectClick} containerClass={Styles['action-button']} />
                    <Typography className={Styles['filename']} variant="subtitle1">{filename}</Typography>
                    {filename && <CloudUploadIcon style={{fontSize:42}} onClick={handleUploadClick} className={Styles.upload} />}
                </div>
            </Panel>
            <ActionButton text="Main Menu" containerClass={Styles.close} onClick={onClose} />
        </Section>
        <div className={Styles.result}>
            <SuccessFailure { ...uploadResult } successMessage="Uploaded Successfully" failMessage="Failed to Upload" />
        </div>
    </Page>
);
UploadTemplateView.propTypes = {
    title: PropTypes.string.isRequired,
    handleSelectClick: PropTypes.func.isRequired,
    inputRef: PropTypes.object.isRequired,
    handleFileSelect: PropTypes.func.isRequired,
    filename: PropTypes.string,
    yearUpdated: PropTypes.func.isRequired,
    handleUploadClick: PropTypes.func.isRequired,
    uploadResult: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    selectedYear: PropTypes.string.isRequired
};

export default UploadTemplateView;